import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { useNavigate, useSearchParams } from 'react-router-dom';
import MinicartLength from './MinicartLength';
import ReactDOM from "react-dom/client";
import Loading from './Loading';

function AbandonedPay() {
   
    const order_id = localStorage.getItem('order_id');
    
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const queryString = window.location.search;
const params = new URLSearchParams(queryString);
const paramArray = {};
const classArray = {};
for (const [key, value] of params) {
  const matches = key.match(/^([^[]+)\[([^[]+)\]$/);
  if (matches) {
    const groupName = matches[1];
    const fieldName = matches[2];
    if (!paramArray[groupName]) {
      paramArray[groupName] = {};
    }
    if (!classArray[groupName]) {
      classArray[groupName] = {};
    }
    paramArray[groupName][fieldName] = value;
    classArray[groupName][fieldName] = "0";
  } else {
    paramArray[key] = value;
    classArray[key] = "0";
  }
}

useEffect(()=>{
        setTimeout(() => {
            const order_id = localStorage.getItem('order_id');
            addtocart(order_id,paramArray,classArray);
           navigate("/smww/cart");
          }, 3500);
       
    },[order_id])


   

    async function addtocart(order_id,lineitems,classroom) {
       
        
        const postData = {
         lineitems:lineitems,
         country:'',
        courses_classroom:classroom,
          order_id: order_id,
          
          uid:localStorage.getItem('drupal_uid')
        }
        const response = await fetch(app_url+'smwwcommercepay/addtocart', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
              'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        if(data.data.result === "order_created") {
            localStorage.setItem('order_id', data.data.order_id);
            localStorage.setItem('drupal_orderid', data.data.drupal_orderid);
            const root = ReactDOM.createRoot(document.getElementById("top-header-cart-icon"));
            root.render(<MinicartLength length={data.data.products.length} />);
            navigate("/smww/cart");
        } else {
               
        }
    }
    return (
        <><Loading /></>
      );
}
export default AbandonedPay;